module.exports = __webpack_public_path__ + "static/media/policy-pig.46b4b9ed.svg";